import { httpPost, httpDownload } from '../../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL, RECHARGE_INVENTORY_TYPE } from '../../../../constants/external-constants';
import { getLocalTimeZone, convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';
import {
     setRechargingHistoryLogsLoading
    , getRechargingHistoryLogs
    , setRechargingHistoryPageSize
    , resetRechargingHistory
    , setRechargingHistoryColSearchStr
} from '../../../../constants/model-reducers/external/recharge/recharging-inventory/recharging-inventory-history.settings';


const defaultState = () => ({
    HistoryTable: DEFAULT_TABLE_RESULT_MODEL,
    IsLoadingTable: false
});

const initialState = defaultState();

export const rechargingHistoryActions = {

    getRechargingHistoryLogs: (rechargingId, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination, Headers } = state().rechargingHistory.HistoryTable;
        var formData = {
            RechargingInventoryId: rechargingId,
            PageIndex: pageIndex,
            PageSize: Pagination.PerPage,
            PageSizes: Pagination.PageSizes,
            Headers: Headers,
           
        };

        dispatch({
            type: setRechargingHistoryLogsLoading,
            isLoadingTable: true
        });

        var result = await httpPost('external/recharge/getRechargingHistoryLogs', formData);

        dispatch({
            type: getRechargingHistoryLogs,
            historyTable: result,
            isLoadingTable: false
        });
    },

    resizeRechargingHistoryLogs: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setRechargingHistoryPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    setRechargingHistoryColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { HistoryTable } = state().rechargingHistory;
        var historyTableHeaderUpd = {
            ...HistoryTable,
            "Headers": {
                ...HistoryTable.Headers,
                [key]: {

                    ...HistoryTable.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setRechargingHistoryColSearchStr,
            historyTable: historyTableHeaderUpd
        });
    },

    resetRechargingHistory: () => (dispatch, state) => {
        dispatch({
            type: resetRechargingHistory
        })
    },

    extractRechargingHistoryLogs: (rechargingId, rechargingInventoryTypeId) => async (dispatch, state) => {
        const { Headers } = state().rechargingHistory.HistoryTable;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;

        let rechargeType = '';
        if (parseInt(rechargingInventoryTypeId) === parseInt(RECHARGE_INVENTORY_TYPE["Circuit"].id)) {
            rechargeType = RECHARGE_INVENTORY_TYPE["Circuit"].label;
        } else if (parseInt(rechargingInventoryTypeId) === parseInt(RECHARGE_INVENTORY_TYPE["Equipment"].id)) {
            rechargeType = RECHARGE_INVENTORY_TYPE["Equipment"].label;
        } else if (parseInt(rechargingInventoryTypeId) === parseInt(RECHARGE_INVENTORY_TYPE["OTC"].id)) {
            rechargeType = RECHARGE_INVENTORY_TYPE["OTC"].label;
        } else {
            rechargeType = "";
        }

        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        const filename = `ATEM ${dealName} ${rechargeType} Recharging Inventory History – ${formattedTimeZoneDate}`;

        var formData = {
            RechargingInventoryId: rechargingId,
            Headers: Headers,
            FileName: filename,
            TimeZone: getLocalTimeZone()
        };
        httpDownload('external/recharge/getExtractRechargingHistoryLogs', formData)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setRechargingHistoryLogsLoading:
            return {
                ...state,
                IsLoadingTable: action.isLoadingTable
            }
        case getRechargingHistoryLogs:
            return {
                ...state,
                HistoryTable: action.historyTable,
                IsLoadingTable: action.isLoadingTable
            }
        case setRechargingHistoryPageSize:
            return {
                ...state,
                HistoryTable: {
                    ...state.HistoryTable,
                    Pagination: {
                        ...state.HistoryTable.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setRechargingHistoryColSearchStr:
            return {
                ...state,
                HistoryTable: action.historyTable,
            }
        case resetRechargingHistory:
            return initialState;
        default:
            return state;
    }
}